<template>
  <div class="filter-box">
    <div class="d-flex">
      <input type="text" :class="['search', {'full':route === 'Runs'}]" placeholder="Type and hit enter to search." 
        @keypress="search" v-model="searchKey" :disabled="exclusive.loading || runs.loading" />
      <div :class="['more-filter', {disabled:brands.loading || services.serviceLoading}]">
        <div class="trigger" @click="showFilter" :disabled="true">
          <i class="fas fa-filter"></i>
          Filter
        </div>
      </div>
    </div>
    <transition name="slide-down">
      <div class="filter-content" v-show="show">
        <div class="row">
          <div class="column col-field medium-10 medium-offset-1">
            <div class="column medium-12">
              <label>Date Range</label>
            </div>
            <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']">
              <div class="datepicker-box">
                <datepicker :format="calendarFormat" :class="['datepicker inline', {'has-error':error.since}]"
                  v-model="since.date" v-on:input="changeDate('since')"
                  :disabled-picker="exclusive.loading || runs.loading" :input-class="{'datepicker-empty':error.since}"
                  :placeholder="$t('transactions.filter.from')"></datepicker>
              </div>
              <div class="row time-selector">
                <div class="column padded medium-4">
                  <select v-model="since.hour" @change="changeTime('since')"
                    :disabled="exclusive.loading || runs.loading" :class="{'has-error':error.since}">
                    <option v-for="n in maxHour" :value="leadingZero(n)" :key="n">{{ leadingZero(n) }}</option>
                  </select>
                </div>
                <div class="column padded medium-4">
                  <select v-model="since.minute" @change="changeTime('since')"
                    :disabled="exclusive.loading || runs.loading" :class="{'has-error':error.since}">
                    <option v-for="n in 60" :value="leadingZero(n - 1)" :key="n">{{ leadingZero(n - 1) }}</option>
                  </select>
                </div>
                <div class="column medium-4">
                  <select v-model="since.amPm" @change="changeTime('since')"
                    :disabled="exclusive.loading || runs.loading" :class="{'has-error':error.since}">
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>
              </div>
            </div>
            <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']">
              <div class="datepicker-box">
                <datepicker :format="calendarFormat" class="datepicker inline"
                  v-model="until.date" v-on:input="changeDate('until')"
                  :disabled-picker="exclusive.loading || runs.loading" :input-class="{'datepicker-empty':error.until}"
                  :placeholder="$t('transactions.filter.to')"></datepicker>
              </div>
              <div class="row time-selector">
                <div class="column padded medium-4">
                  <select v-model="until.hour" @change="changeTime('until')"
                    :disabled="exclusive.loading || runs.loading" :class="{'has-error':error.until}">
                    <option v-for="n in maxHour" :value="leadingZero(n)" :key="n">{{ leadingZero(n) }}</option>
                  </select>
                </div>
                <div class="column padded medium-4">
                  <select v-model="until.minute" @change="changeTime('until')"
                    :disabled="exclusive.loading || runs.loading" :class="{'has-error':error.until}">
                    <option v-for="n in 60" :value="leadingZero(n - 1)" :key="n">{{ leadingZero(n - 1) }}</option>
                  </select>
                </div>
                <div class="column medium-4">
                  <select v-model="until.amPm" @change="changeTime('until')"
                    :disabled="exclusive.loading || runs.loading" :class="{'has-error':error.until}">
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-show="!!error.since" style="margin-bottom: 15px">
          <div class="column col-field medium-10 medium-offset-1">
            <div class="error-msg"><b>{{ error.since }}</b></div>
          </div>
        </div>

        <div class="row">
          <div class="column col-field medium-12">
            <div class="column medium-12">
              <label>Service Type</label>
            </div>
            <div class="select-all" @click="selectAllBrands()">
              <div class="select-brand">
                <i :class="['fa-lg', selectedAllServices ? 'fa-check-square fas' : 'far fa-square' ]"></i>
              </div>
              <div class="brand">
                <label>Select All Brands</label>
              </div>
            </div>
            <div v-for="brand in brands.list" v-if="serviceList(brand.id).length" class="services" :key="brand.id">
              <div class="select-brand" @click="selectBrand(brand.id)">
                <i :class="['fa-lg', selectedBrand.indexOf(brand.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]"></i>
              </div>
              <div class="brand">
                <div class="head" @click="toggleBrand(brand.id)">
                  <i class="fas fa-angle-down" v-if="openBrand.indexOf(brand.id) > -1"></i>
                  <i class="fas fa-angle-up" v-else></i>
                  {{ brand.name }}
                </div>
                <transition name="height">
                  <ul class="body" v-show="openBrand.indexOf(brand.id) > -1">
                    <li v-for="service in serviceList(brand.id)" @click="toggleService(service.id, brand.id)" :key="service.id">
                      <i :class="['fa-lg', selectedService.indexOf(service.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]"></i>
                      {{service.label}}
                    </li>
                  </ul>
                </transition>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-show="!!error.service">
          <div class="column col-field medium-10 medium-offset-1">
            <div class="error-msg"><b>{{ error.service }}</b></div>
          </div>
        </div>

        <div class="row" style="margin-top: 30px">
          <div :class="['column col-btn', 'medium-10 medium-offset-1']">
            <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']" v-if="!shrink">
              <div class="button cta warning block small" @click="show = false">Close</div>
            </div>
            <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']">
              <div :class="['button cta success block small', {disabled: exclusive.loading || runs.loading}]" @click="loadList">Apply Filter</div>
            </div>
            <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']" v-if="shrink">
              <div class="button cta warning block small" @click="show = false">Close</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import ApiBrands from '@/modules/api/brands'
import ApiServices from '@/modules/api/services'

export default {
  name: 'table-filter',
  components: { datepicker },
  props: ['shrink'],
  data () {
    return {
      show: false,
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      error: {
        since: '',
        until: '',
        service: ''
      },
      openBrand: [],
      selectedBrand: [],
      selectedAllServices: true,
      selectedService: [],
      loaded: []
    }
  },
  computed: {
    route () { return this.$route.name },
    runs () { return this.$store.state.runs },
    refresh () { return this.runs.refresh },
    exclusive () { return this.runs.exclusive },
    airports () { return this.$store.state.airports.list },
    searchKey: {
      get () { return this.runs.search },
      set (x) { this.$store.commit('runs/setRunsDetails', {search: x}) }
    },
    since () {
      let date = moment(this.runs.since, 'MM/DD/YYYY hh:mmA')
      return {
        date: date.format('MM/DD/YYYY'),
        hour: date.format('hh'),
        minute: date.format('mm'),
        amPm: date.format('A')
      }
    },
    until () {
      let date = moment(this.runs.until, 'MM/DD/YYYY hh:mmA')
      return {
        date: date.format('MM/DD/YYYY'),
        hour: date.format('hh'),
        minute: date.format('mm'),
        amPm: date.format('A')
      }
    },
    brands () { return this.$store.state.brands },
    services () { return this.$store.state.services },
    _serviceList () { return this.services.list },
    qualifiedDriver () { return this.runs.qualifiedDriver },
    dispatchStore () { return this.$store.state.dispatch },
    driverPanel () { return this.dispatchStore.driverPanelOpen },
    tabActive () { return this.dispatchStore.tabActive }
  },
  methods: {
    showFilter () {
      if (this.brands.loading || this.services.serviceLoading) return
      this.show = !this.show
    },
    loadList () {
      let initSet = {}
      if (!this.runs.since) {
        initSet.since = `${moment().format('MM/DD/YYYY')} 00:00AM`
      }
      if (!this.runs.until) {
        initSet.until = `${moment().format('MM/DD/YYYY')} 23:59PM`
      }
      if (Object.keys(initSet).length) {
        this.$store.commit('runs/setRunsDetails', initSet)
      }
      this.error.since = ''
      let hasError = false
      if (moment(this.runs.until, 'MM/DD/YYYY hh:mmA').isBefore(moment(this.runs.since, 'MM/DD/YYYY hh:mmA'))) {
        this.error.since = 'Invalid date range.'
        hasError = true
      }
      this.error.service = ''
      if (!this.selectedService.length) {
        this.error.service = 'Please select at least one service type.'
        hasError = true
      }
      // selectedService
      if (hasError) return
      this.$store.commit('runs/setRunsDetails', {selectedServices: this.selectedService})

      this.getExclusive()
      this.updateDispatchSync()
      if (!this.airports.length) {
        this.getAirportList()
        return
      }
      this.getRuns()
    },
    getExclusive () {
      let self = this
      if (self.runs.exclusive.loading) return

      self.$store.commit('runs/setExclusiveDetails', {
        list: [],
        loading: true
      })
      self.show = false
      self.$sdk.post('/runs/reservations', {
        token: self.$store.state.session.sessionToken,
        // search: self.searchKey,
        since: moment(self.runs.since, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD HH:mm:00'),
        until: moment(self.runs.until, 'MM/DD/YYYY hh:mmA').format('YYYY-MM-DD HH:mm:59'),
        serviceTypeId: [...self.selectedService, 0]
      }, res => {
        self.$store.commit('runs/setExclusiveDetails', {loading: false})
        let list = []
        if (!res.error) {
          res.list.forEach(rsvp => {
            let flightInfo = null
            if (rsvp.pickupLocation.geofenceType === 'airport' || rsvp.dropoffLocation.geofenceType === 'airport') {
              let flightNumber = rsvp.dropoffFlightNumber
              if (rsvp.pickupLocation.geofenceType === 'airport') {
                flightNumber = rsvp.flightNumber
              }
              flightInfo = {
                airportCode: rsvp.airportCode,
                airline: rsvp.airlineCode,
                flightNo: flightNumber,
                isDeparture: rsvp.pickupLocation.geofenceType !== 'airport'
              }
            }
            let etaInSec = rsvp.etaInSec
            etaInSec += 60 * 30 // add 30mins to ETA
            list.push({
              type: 'rsvp',
              id: rsvp.ID,
              driverPayment: rsvp.payment.driverPay + rsvp.payment.tipAmount + rsvp.payment.driverBonus + rsvp.gasFee + rsvp.payment.pickupFee,
              pickupDate: moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
              pickup: rsvp.pickupLocation,
              dropoff: rsvp.dropoffLocation,
              service: {
                name: rsvp.serviceType.name,
                color: rsvp.serviceType.color
              },
              flightInfo: flightInfo,
              pax: rsvp.passengers,
              isOptinShared: rsvp.isOptinShared,
              rsvps: [{
                id: rsvp.ID,
                eta: etaInSec,
                pickupDate: moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
                pickup: rsvp.pickupLocation,
                dropoff: rsvp.dropoffLocation,
                pax: rsvp.passengers,
                luggage: rsvp.luggage,
                timeToNext: null,
                distanceToNext: null
              }]
            })
          })
        }
        self.$store.commit('runs/setExclusiveDetails', {list: list})
      }, '2.0')
    },
    getAirportList () {
      let self = this
      if (self.airports.length) {
        self.getRuns()
        return
      }

      self.$store.commit('airports/setLoading', true)
      self.$sdk.get('/airports', {}, r => {
        self.$store.commit('airports/setLoading', false)
        let list = []
        if (!r.error) {
          r.list.forEach(function (data) {
            let add1 = data.addressLine2 === null ? data.addressLine1 : data.addressLine2
            let add2 = data.addressLine2 === null ? '' : data.addressLine1
            let title = add2 + ' ' + add1 + ', ' + data.city + ', ' + data.state + ' ' + data.zipCode
            if (data.enabled) {
              list.push({
                geofenceId: data.id,
                geofenceType: 'airport',
                address1: add1,
                address2: add2,
                city: data.city,
                lat: data.lat,
                lng: data.lng,
                state: data.state,
                title: data.name || title,
                zip: data.zipCode,
                description: data.description,
                airportCode: data.airportCode,
                locationId: data.locationId
              })
            }
          })
        }
        self.$store.commit('airports/setList', list)
        self.getRuns()
      })
    },
    getRuns () {
      let self = this
      if (self.runs.loading) return
      self.$store.commit('runs/setRunsDetails', {
        list: [],
        loading: true
      })
      self.show = false
      self.$sdk.post('/runs', {
        token: self.$store.state.session.sessionToken,
        search: self.searchKey,
        pickupSince: moment(self.runs.since, 'MM/DD/YYYY hh:mmA').utc().format('YYYY-MM-DD HH:mm:00'),
        pickupUntil: moment(self.runs.until, 'MM/DD/YYYY hh:mmA').utc().format('YYYY-MM-DD HH:mm:59'),
        serviceTypeId: [...self.selectedService, 0]
      }, res => {
        self.$store.commit('runs/setRunsDetails', {loading: false})
        let list = []
        if (!res.error) {
          this.$store.commit('runs/setRunsDetails', {selected: null})
          res.list.forEach(run => {
            if (run.providerId || self.runs.blackList.indexOf(run.id) > -1) {
              self.$store.commit('runs/removeBlackList', run.id)
              return
            }
            let firstRsvp = run.rsvps.find(x => x.order === 0)
            let lastRsvp = run.rsvps.find(x => x.order === run.rsvps.length - 1)
            let rsvpIDs = []
            let services = []
            let rsvps = []
            let driverPayment = 0
            let pax = []
            let brandId = run.rsvps[0].brandId
            run.rsvps.forEach(rsvp => {
              rsvpIDs.push(rsvp.id)
              let etaInSec = rsvp.etaInSec
              etaInSec += 60 * 30 // add 30mins to ETA
              rsvps.push({
                id: rsvp.id,
                eta: etaInSec,
                pickupDate: moment(rsvp.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'),
                pickup: rsvp.pickup,
                dropoff: rsvp.dropoff,
                pax: rsvp.passengers || 1,
                luggage: rsvp.luggage || 0,
                timeToNext: null,
                distanceToNext: null,
                service: rsvp.serviceType
              })
              if (rsvp.serviceType && services.findIndex(x => x.name === rsvp.serviceType.name) === -1) {
                services.push({
                  id: rsvp.serviceType.id,
                  name: rsvp.serviceType.name || '',
                  color: rsvp.serviceType.color || ''
                })
              }
              driverPayment += rsvp.paidForProvider + rsvp.tipAmount + rsvp.bonusToProvider + rsvp.pickupFee + rsvp.gasFee
              pax.push(rsvp.passengers)
            })
            list.push({
              type: 'runs',
              id: run.id,
              brandId: brandId,
              rsvpIDs: rsvpIDs,
              driverPayment: driverPayment,
              pickupDate: moment(run.firstPickup, 'X').format('MM/DD/YYYY hh:mmA'),
              lastDropoff: moment(run.lastDropoff, 'X').format('MM/DD/YYYY hh:mmA'),
              pickup: firstRsvp.pickup,
              dropoff: lastRsvp.dropoff,
              services: services,
              pax: pax,
              rsvps: rsvps
            })
          })
        }
        self.$store.commit('runs/setRunsDetails', {list: list})
        if (self.$route.name === 'Dispatch' && self.tabActive.rsvp === 'runs' && self.driverPanel && self.tabActive.driver === 'availability') {
          let runsInMap = self.runs.other.runsInMap
          if (runsInMap.length === 1) {
            let i = self.runs.list.findIndex(x => x.id === runsInMap[0])
            if (i > -1) {
              self.$store.commit('runs/setDriverAvailabilityData', {
                checkId: self.runs.list[i].rsvpIDs[0],
                rsvpData: self.runs.list[i].rsvps.find(x => x.id === self.runs.list[i].rsvpIDs[0])
              })
            }
          }
        }
      }, '2.0')
    },
    search (event) {
      let self = this

      if (event && event.key === 'Enter') {
        this.$store.commit('runs/setRunsDetails', {selected: []})
        this.getRuns()
        this.getExclusive()
        this.updateDispatchSync()
      }
    },
    calendarFormat (date) { return moment(date, 'MM/DD/YYYY').format('MM/DD/YYYY') },
    changeDate (type) {
      this.error[type] = ''

      let format = 'MM/DD/YYYY hh:mmA'
      let selectedTime = ''
      let target = this[type]

      selectedTime = moment(target.date)
      selectedTime = moment(`${selectedTime.format('MM/DD/YYYY')} ${target.hour}:${target.minute}${target.amPm}`, 'MM/DD/YYYY hh:mmA')
      let update = {}
      update[type] = selectedTime.format(format)
      this.$store.commit('runs/setRunsDetails', update)
    },
    changeTime (type) {
      let target = this[type]
      let _obj = {}
      _obj[type] = `${target.date} ${target.hour}:${target.minute}${target.amPm}`
      this.$store.commit('runs/setRunsDetails', _obj)
    },
    leadingZero (n) { return parseInt(n) < 10 ? '0' + n : n },
    updateDispatchSync () {
      let self = this
      self.$sdk.get('/admin/rsvp/dispatch/sync', {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          console.log(r)
          return
        }
        self.$store.commit('dispatch/setLastSync', moment(r.time, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA'))
      })
    },
    serviceLabel ( code ) { return services.getServiceName(code) },
    serviceList (brandId) {
      let serviceList = this.$store.state.services.list.filter(x => x.brandId === brandId)
      return serviceList
    },
    toggleBrand (brandId) {
      if (this.openBrand.indexOf(brandId) > -1) {
        let index = this.openBrand.indexOf(brandId)
        this.openBrand.splice(index, 1)
      } else {
        if(this.openBrand.indexOf(brandId) === -1) {
          this.openBrand.push(brandId)
        }
      }
    },
    toggleService (serviceId, brandId) {
      if (this.selectedService.indexOf(serviceId) > -1) {
        let index = this.selectedService.indexOf(serviceId)
        this.selectedService.splice(index, 1)
      } else {
        this.selectedService.push(serviceId)
      }

      let services = this.serviceList(brandId)
      let checkServices = services.map(brand => brand.id)
      if (checkServices.every(id => this.selectedService.includes(id))) {
        if(this.selectedBrand.indexOf(brandId) === -1) {
          this.selectedBrand.push(brandId)
        }
      } else {
        if(this.selectedBrand.indexOf(brandId) > -1) {
          let index = this.selectedBrand.indexOf(brandId)
          this.selectedBrand.splice(index, 1)
        }
      }
    },
    selectAllBrands () {
      let brands = this.brands.list
      if(!this.selectedAllServices){
        brands.forEach(brand => {
          if(this.selectedBrand.indexOf(brand.id) === -1) {
            this.selectedBrand.push(brand.id)
          }
          if(this.openBrand.indexOf(brand.id) === -1) {
            this.openBrand.push(brand.id)
          }
          let services = this.serviceList(brand.id)
          services.forEach(service => {
            if(this.selectedService.indexOf(service.id) === -1) {
              this.selectedService.push(service.id)
            }
          })
        })
      } else {
        this.selectedBrand = []
        this.selectedService = []
      }
      this.selectedAllServices = !this.selectedAllServices
    },
    selectBrand (brandId) {
      let services = this.serviceList(brandId)
      if (this.selectedBrand.indexOf(brandId) > -1) {
        let index = this.selectedBrand.indexOf(brandId)
        this.selectedBrand.splice(index, 1)
        services.forEach(service => {
          let index = this.selectedService.indexOf(service.id)
          this.selectedService.splice(index, 1)
        })
        this.selectedAllServices = false
      } else {
        if(this.selectedBrand.indexOf(brandId) === -1) {
          this.selectedBrand.push(brandId)
        }
        services.forEach(service => {
          if(this.selectedService.indexOf(service.id) === -1) {
            this.selectedService.push(service.id)
          }
        })
        if(this.openBrand.indexOf(brandId) === -1) {
          this.openBrand.push(brandId)
        }
      }

      if (this.brands.list.every(brand => this.selectedBrand.includes(brand.id))) {
        this.selectedAllServices = true
      }
    },
    getBrands () {
      let self = this
      if (!self.brands.list.length) {
        if (self.brands.loading) {
          self.getServices()
          return
        }
        ApiBrands.getBrands(self, function (res) {
          self.setDefaultBrands()
        })
      } else {
        self.setDefaultBrands()
        // self.getServices()
      }
    },
    setDefaultBrands () {
      let self = this
      this.brands.list.forEach(brand => {
        self.selectedBrand.push(brand.id)
      })
      self.loaded.push('brands')
      self.getServices()
    },
    getServices () {
      let self = this
      if (!self._serviceList.length && !self.services.serviceLoading) {
        self.$store.commit('services/setServiceLoading', true)
        ApiServices.getAllService(self, r => {
          self.$store.commit('services/setServiceLoading', false)
        })
      } else {
        this.setDefaultServices()
      }
    },
    setDefaultServices () {
      let services = []
      this._serviceList.forEach(service => {
        if (this.brands.list.findIndex(x => x.id === service.brandId) > -1) {
          services.push(service.id)
        }
      })
      if (!this.selectedService.length) this.selectedService = services
      this.loaded.push('services')
    }
  },
  watch: {
    refresh (value) {
      if (!value) return

      this.getRuns()
      this.getExclusive()
      this.$store.commit('runs/setRunsDetails', {refresh: false})
    },
    _serviceList (val) {
      if (val) {
        this.setDefaultServices()
      }
    },
    'brands.list' (val) {
      if (val.length) {
        this.setDefaultBrands()
      }
    },
    loaded (val) {
      if (val.indexOf('brands') > -1 && val.indexOf('services') > -1) {
        this.loadList()
      }
    },
    'qualifiedDriver.refresh' (val) {
      if (val) {
        this.getRuns()
        this.$store.commit('runs/setQualifiedDriversData', {refresh: false})
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.getBrands()
    }, 200)
  }
}
</script>

<style lang="scss" scoped>
.d-flex{
  display: flex;
}
.filter-box{
  position: relative;
  z-index: 3;
}
.search{
  margin: 0 0 0 50px;
  border-radius: 0;
  padding: 0 15px;
  height: 50px;
  line-height: 50px;
  border-top: 0;
  border-bottom: 0;
  border-color: rgba(0, 0, 0, 0.3);
  max-width: 350px;

  &.full{
    max-width: calc(100% - 142px);
  }
}
.more-filter{
  display: inline-block;
  height: 50px;
  line-height: 50px;
  border-right:1px solid rgba(0,0,0, .3);
  background: #fff;
  cursor: pointer;
  min-width: 160px;

  &.disabled{
    background: #fafafa;
    cursor: default;
  }
}
.trigger{
  padding: 0 15px;

  i{
    color: #999;
    margin-right: 3px;
  }
}
.filter-content{
  background: #eaf1f3;
  position: absolute;
  top: 51px;
  left: 0;
  width: calc(100% - 1px);
  max-height: calc(100vh - 50px);
  overflow-y: auto;
  padding: 20px 15px;
  border-bottom: 1px solid #aaa;
}
.column.padded{
  padding-right: 10px;
}
label{
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
  display: block;
  color: #555;
}
.datepicker-box{
  display: inline-block;
  width: 100%;
}
.time-selector{
  padding: 5px 0;

  select{
    border-color: #ccc;
    padding: 3px;
  }
}

.error-msg{
  width: 100%;
  padding: 2px 5px;
  font-size: 12px;
  color: #f33a27;
  transform-origin: top center;
}

.select-brand {
  float: left;
  width: 3%;
  color: #999;
  cursor: pointer;
  i{
    padding: 6px 0;
    margin-right: 5px;
    &.fa-check-square{ color: #5ec1ac; }
  }
}
.brand {
  float: left;
  width: 97%;
}
.select-all {
  .brand {
    width: auto;
  }
  .brand label {
    cursor: pointer;
    padding: 4px 0;
    display: inline-block;
  }
}
.services{
  clear: both;

  .head{
    padding: 5px;
    background: #5ec1ac;
    color: #fff;
    border: 1px solid #3d8374;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;

    i{ margin-right: 5px; }
  }
  .body{
    list-style: none;
    margin: 0;
    padding: 5px 0;
    -webkit-column-count: 3;
    -moz-column-count: 3;
    column-count: 3;
    column-gap: 5px;
    background: #fff;
    border: 1px solid #3d8374;
    max-height: 999px;

    li{
      padding: 3px 10px;
      font-size: 13px;
      cursor: pointer;

      &:hover{ background: #f3f3f3; }
      i{
        vertical-align: middle;
        margin-right: 5px;
        &.fa-check-square{ color: #5ec1ac; }
      }
    }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

@media screen and (max-width: 430px) {
  .filter-box {
    z-index: 101;
  }

  .filter-content {
    padding-bottom: 80px;
  }

  .medium-6 {
    width: 50%;
  }

  .time-selector {
    display: flex;
    select {
      padding: 5px;
    }
    .column.padded {
      padding-right: 3px;
    }
  }

  .select-all .brand label {
    padding: 4px 15px;
  }

  .services {
    display: flex;
    .select-brand {
      width: auto;
    }
    
    .brand {
      width: 100%;

      .body {
        display: flex;
        flex-direction: column;
        flex-flow: wrap;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Runs/TableFilter.vue